import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import PageContainer from "~/components/PageContainer";
import Logout from "~/pages/Auth/Logout";
import PageId from "~/utils/PageId";

export const Route = createFileRoute("/logout")({
  staticData: {
    pageId: PageId.LOGOUT,
    titleKey: "pageTitles.logout",
    hideNav: true,
  },
  component: LogoutRoute,
});

function LogoutRoute() {
  const { t } = useTranslation("common");
  return (
    <PageContainer title={t("pageTitles.logout")} hideNav>
      <Logout />
    </PageContainer>
  );
}
